import { original } from '@reduxjs/toolkit'
import { random } from 'underscore'
import { ChainIcon } from '../../../../assets/icons/chain'
import { FileWithArrowUp } from '../../../../assets/icons/fileWithArrowUp'
import { TextWithFile } from '../../../../pages/Interpretations/[id]/Interpretations.style'
import { Button, SignalLevel } from '../../../customStyledElements'
import { THead } from '../../main/indicators-signals-table/IndicatorsSignalTable'
import { EmptyTable } from '../../../../pages/subjects/Subject'
import { getSubjectId } from '../../../../pages/biomarkers/[id]/IndicatorsAndSignals'
import { Link } from 'react-router-dom'
import { MAX_URL_LENGTH } from '../../../../pages/subjects/SubjectEdit'

export const ConnectButton = (props: any) => {
  let { onConnect, connectIds, item, ind } = props
  let isConnect = (connectIds || {})[item._id]

  return (
    <button className={'btn'}
            style={{marginRight: '20px'}}
      onClick={() => {
        onConnect(item, ind, !isConnect)
      }}
    >
      {!isConnect ? 'Connect' : 'Disconnect'}
    </button>
  )
}

export const Empty = () => {
  return <EmptyTable name={'interpretation'}/>
}

export const NothingFound = () => {
  return (
    <tr>
      <td colSpan={1000} className={'nothing-found'}>
        Nothing Found ....
      </td>
    </tr>
  )
}

export const ConnectToInterpretationHead = () => {
  return (
    <THead>
      <tr>
        <td>Connect/Disconnect</td>
        <td>Signal name</td>
        <td>Unit</td>
        <td>RAG Signals</td>
        <td>Parent Indicator</td>
      </tr>
    </THead>
  )
}

export const ConnectToInterpretationBody = (props: any) => {
  let { ind, item, search, onConnect, connectIds } = props

  return (
    <tbody>
      <tr>
        <td>
          <ConnectButton
            item={item}
            ind={ind}
            onConnect={onConnect}
            connectIds={connectIds}
          />
        </td>
        <td>
          <TextWithFile>
            <Link to={'/' + getSubjectId() + '/diseases/' + item._id}>
              <FileWithArrowUp />
            </Link>
            <p>
              {item.name?.slice(0, MAX_URL_LENGTH)}
              {item.name?.slice(MAX_URL_LENGTH)?.length > 0 && '...'}
            </p>
          </TextWithFile>
        </td>
        <td>
          <p>Cell/ql' 'U/L'</p>
        </td>
        <td>
          <SignalLevel>0-249</SignalLevel>
        </td>
        <td>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ChainIcon style={{ marginRight: '5px' }} />
            {item?.parentIndicator}
          </div>
        </td>
      </tr>
    </tbody>
  )
}
